<template>
  <div class="page-user-login">
    <div class="top">
      <img :src="require('../../assets/logo_01.png')" alt="">
    </div>
    <div class="login_box">
      <h2>校园参观登记</h2>
      <van-form @submit="onSubmit">
        <van-field
          name="phone"
          v-model="loginInfo.phone"
          placeholder="请输入手机号码"
          type="tel"
          center
          size="large"
          clearable
          :rules="[{ required: true }]"
        >
        <template slot="left-icon">
          <van-icon name="phone-circle-o" size="0.7rem" color="#999" />
        </template>
        </van-field>
        <!-- <van-field
          v-model="password"
          type="password"
          name="密码"
          label="密码"
          placeholder="密码"<van-icon name="phone-circle-o" />
          :rules="[{ required: true }]"<van-icon name="comment-circle-o" />
        /> -->
        <van-field
          name="验证码"
          center
          size="large"
          v-model="loginInfo.code"
          clearable
          :maxlength="4"
          placeholder="请输入短信验证码"
          :rules="[{ required: true }]"
        >
          <template #button>
            <van-button  @click.prevent="getcode" size="small"  :disabled="codeNum != 60 || !loginInfo.phone">
              {{ codeNum == 60 ? '发送验证码' : codeNum + 's后重新获取 '}}
            </van-button>
          </template>
          
        <template slot="left-icon">
          <van-icon name="comment-circle-o" size="0.7rem" color="#999" />
        </template>
        </van-field>
        <div style="margin-top: 26px;">
          <van-button block round type="info" native-type="submit">登录</van-button>
        </div>
      </van-form>
      
    </div>
    <!-- <van-notify v-model="notifyShow" type="success">
      <van-icon name="success" style="margin-right: 4px;" />
      <span>验证码发送成功，请注意查收</span>
    </van-notify> -->
  </div>
</template>

<script>
import {setToken} from '@/utils/auth'
import { getcode, phoneLogin } from '@/api/login'
import { mapMutations } from 'vuex'
export default {
  name: 'user-chat',
  data () {
    return {
      BASE_URL: process.env.VUE_APP_API_BASE_URL == '/' ? '' : process.env.VUE_APP_API_BASE_URL,
      codeNum: 60,
      loginInfo: {},
      notifyShow: false
    }
  },
  // watch: {
  //   codeNum (newVal) {
  //     if (newVal === 0) {
  //       this.codeNum = 60
  //     }
  //   }
  // },
  created () {
    this.setCampusId(this.$route.query.campusId || this.$route.query.zoneId)
  },
  methods: {
    ...mapMutations(['setCampusId']),
    // 一建登录按钮
    onSubmit () {
     // TODO
    //  setToken(1)
     phoneLogin(this.loginInfo).then(res => {
       if(res.code === 0) {
         setToken(res.data.token)
         this.$toast.success('登录成功')
          this.$router.push('/index')
       }else{
         this.$toast.fail(res.msg)
       }
     }).catch(err => {
      console.error(err, 'err');
      this.$toast('登录失败:请求失败')
     })
    },
   // 获取手机验证码
   getcode () {
    if (!this.loginInfo.phone) {
      this.$toast('请输入手机号码')
      return 
    }
    let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
    console.log(reg.test(this.loginInfo.phone), 'sss');
    if (!reg.test(this.loginInfo.phone)) {
      this.$toast('手机号格式错误')
      return
    }
    getcode({phone: this.loginInfo.phone}).then(res => {
      if(res.code === 0) {
        // this.$toast('验证码发送成功，请注意查收')
        this.$notify({ type: 'success', message: '验证码发送成功，请注意查收' });
        // this.notifyShow = true
        // setTimeout(() => {
        //   this.notifyShow = false
        // }, 2000)
        this.codeNum--
        let timer = setInterval(() => {
          this.codeNum--
          if (this.codeNum === 0) {
            this.codeNum = 60
            clearInterval(timer)
          }
        }, 1000)
      }else{
        this.$toast.fail(res.msg)
      }
    }).catch(err => {
      console.error(err, 'err');
      this.$toast('验证码发送失败')
    })
   },
   GetRequest() {
    var url = location.href;
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
      var str = url.split('?');
      var strs = str[1].split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
      }
    }
    return theRequest;
  },
   
  }
}
</script>

<style scoped lang='less'>
.page-user-login {
  text-align: center;
  position: relative;
  height: 100vh;
  overflow-y: auto;    /*滚动*/
  box-sizing:border-box;
  // padding-top:100px;
  .top {
    height: 50vh;
    // background-color: #266ffc;
    overflow: hidden;
    // background-image: linear-gradient(to top, #209cff 0%, #68e0cf 100%);
    background-image: linear-gradient(to top,  #72afd3  0%, #37ecba 100%);
    img {
      margin-top: 13%;
      width: 30%;
      // height: 30%;

    }
  }
  .login_box {
    width: 85vw;
    margin: 0 auto;
    background-color: #fff;
    padding: 26px 10px;
    border-radius: 10px;
    transform: translateY(-18vh);
    // box-shadow: 0 0 13px 5px rgba(39, 108, 251, .223);
    box-shadow: 0 0 13px 5px rgba(92, 189, 207, .223);
  }
  h2 {
    color: #333;
    margin-bottom: 15px;
    letter-spacing: 3px;
  }
  
  .register_btn {
    color: #666;
    transform: translateY(-2vh);

  }
  .van-cell {
    margin-bottom: 0.2rem;
    &::after {
      
      border-bottom-color: #d7d7d7;
    }
    /deep/.van-field__control {
      padding-left: 8px !important
    }
  }
}
</style>
